// src/components/NavIcons.jsx — FILLED variants of the bottom-nav icons, shown
// on the active tab (WhatsApp swaps outline → solid when a tab is selected).
// Each takes { size, color } and fills with currentColor/color.
const S = (size = 21, color = 'currentColor') => ({ width: size, height: size, viewBox: '0 0 24 24', fill: color, xmlns: 'http://www.w3.org/2000/svg' });

export const FiHome = ({ size, color }) => (
  <svg {...S(size, color)}><path d="M11.3 2.6a1 1 0 0 1 1.4 0l8 7.3c.2.2.3.4.3.7V20a1 1 0 0 1-1 1h-4.5a1 1 0 0 1-1-1v-5h-3v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9.4c0-.3.1-.5.3-.7z"/></svg>
);
export const FiLearn = ({ size, color }) => (
  <svg {...S(size, color)}><path d="M12 3 1.5 8 12 13l8.5-4.05V15a1 1 0 0 0 2 0V8z"/><path d="M6 13.6v3.2c0 .5.26.95.7 1.2C8.1 18.8 10 19.5 12 19.5s3.9-.7 5.3-1.5c.44-.25.7-.7.7-1.2v-3.2L12 16.3z"/></svg>
);
export const FiChat = ({ size, color }) => (
  <svg {...S(size, color)}><path d="M4 3h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H8l-4 4a1 1 0 0 1-1-.7V5a2 2 0 0 1 2-2z"/></svg>
);
export const FiBell = ({ size, color }) => (
  <svg {...S(size, color)}><path d="M12 2a6 6 0 0 0-6 6c0 4-1.5 6-2.3 6.9A1 1 0 0 0 4.4 17h15.2a1 1 0 0 0 .7-1.7C19.5 14 18 12 18 8a6 6 0 0 0-6-6z"/><path d="M9.5 19a2.5 2.5 0 0 0 5 0z"/></svg>
);
export const FiDashboard = ({ size, color }) => (
  <svg {...S(size, color)}><rect x="3" y="3" width="8" height="8" rx="2"/><rect x="13" y="3" width="8" height="5" rx="2"/><rect x="13" y="10" width="8" height="11" rx="2"/><rect x="3" y="13" width="8" height="8" rx="2"/></svg>
);
export const FiGroup = ({ size, color }) => (
  <svg {...S(size, color)}><circle cx="9" cy="8" r="4"/><path d="M1 20a8 8 0 0 1 16 0 1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z"/><path d="M16.5 5.5a3.5 3.5 0 0 1 0 6.9c1.9.9 3.5 2.9 3.5 5.6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 8 8 0 0 0-6-7.7 3.5 3.5 0 0 0-.5-4.8z"/></svg>
);
export const FiBroadcast = ({ size, color }) => (
  <svg {...S(size, color)}><path d="M3 10v4a1 1 0 0 0 1 1h2l3 4a1 1 0 0 0 1.8-.6V5.6A1 1 0 0 0 9 5L6 9H4a1 1 0 0 0-1 1z"/><path d="M15 8a4 4 0 0 1 0 8" fill="none" stroke={color || 'currentColor'} strokeWidth="2" strokeLinecap="round"/><path d="M17.5 5.5a7 7 0 0 1 0 13" fill="none" stroke={color || 'currentColor'} strokeWidth="2" strokeLinecap="round"/></svg>
);
export const FiUsers = FiGroup;
export const FiNewspaper = ({ size, color }) => (
  <svg {...S(size, color)}><path d="M4 4h13a1 1 0 0 1 1 1v13a2 2 0 0 0 2 2H5a3 3 0 0 1-3-3V6a2 2 0 0 1 2-2z"/></svg>
);
export const FiProfile = ({ size, color }) => (
  <svg {...S(size, color)}><circle cx="12" cy="8" r="4.5"/><path d="M3.5 20a8.5 8.5 0 0 1 17 0 1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1z"/></svg>
);
export const FiUpload = ({ size, color }) => (
  <svg {...S(size, color)}><path d="M5 18h14a2 2 0 0 1 0 4H5a2 2 0 0 1 0-4z"/><path d="M11 4.4 6.7 8.7a1 1 0 0 0 1.4 1.4L11 7.2V16a1 1 0 0 0 2 0V7.2l2.9 2.9a1 1 0 0 0 1.4-1.4L13 4.4a1.4 1.4 0 0 0-2 0z"/></svg>
);
